import * as React from 'react'

const defaultColor = '#9BA3B2'
const activeColor = '#3C52EF'

// Greyfinch bird mark (official asset from design). Toggles between the sidebar's default grey and
// the active blue, matching the other patient-sidebar icons.
export default ({ isActive = false }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.20898 5.47461C7.28319 7.9651 10.7483 9.93095 14.4629 11.293L15.8047 10.5166C18.4859 8.96444 21.8835 9.46706 24 11.7295C22.7154 11.6091 21.4308 11.9654 20.3926 12.7314L13.5684 17.7666C12.442 18.5975 10.9933 18.8575 9.64844 18.4697C7.45887 17.8385 5.13638 17.8321 2.94336 18.4512L1 19L0.000976562 17.5889L7.58887 15.8545C7.94331 15.7732 7.98504 15.2846 7.64941 15.1445L5.86621 14.4023C2.19254 12.8714 1.18999 8.13568 3.92773 5.24707L4.20898 5.47461ZM18.9297 4.55762C18.8631 6.28762 18.1695 7.93481 16.9785 9.19141L15.5664 9.93652L14.6309 10.4307C14.5468 10.4751 14.4491 10.4859 14.3574 10.4609C13.5449 10.2393 12.7781 9.87522 12.0928 9.38574L11.8193 9.19141C13.4546 6.83252 15.8061 5.06225 18.5254 4.14355L18.9502 4L18.9297 4.55762Z"
      fill={isActive ? activeColor : defaultColor}
    />
  </svg>
)
